export * from './lib/micro-ui-template-content.module';

export * from './lib/shared/model/content-template.enum';
export * from './lib/shared/model/content-template.interface';
